import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["src", "alt"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.href)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: _ctx.href,
          class: "block"
        }, [
          _createElementVNode("img", {
            src: _ctx.src,
            alt: _ctx.alt,
            class: "w-full rounded-lg"
          }, null, 8 /* PROPS */, _hoisted_3)
        ], 8 /* PROPS */, _hoisted_2))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _ctx.src,
          alt: _ctx.alt,
          class: "w-full rounded-lg"
        }, null, 8 /* PROPS */, _hoisted_4))
  ]))
}